import { setDateRange } from '../State/servicesBreakdownReport';
import fetchServicesBreakdownReport from '../Services/fetchServicesBreakdownReport';

export default (value) => async (dispatch) => {
  dispatch(setDateRange(value));
  dispatch(fetchServicesBreakdownReport());
}
